// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mc-qsns[data-v-d86d8550]{font-family:Noto Sans JP;letter-spacing:2px;font-size:20px;text-align:center;margin-top:12px;margin-bottom:8px;color:#fff;-webkit-text-stroke:1px grey;font-weight:700;font-style:italic}", ""]);
// Exports
module.exports = exports;
